export default __webpack_public_path__ + "static/media/meWithAward.ce427cec.png";